module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "city",
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.regionInfo))]), _vm._v(" "), _c('div', {
    staticClass: "cityTabs",
    class: {
      hidden: !_vm.visible
    }
  }, [_c('span', {
    attrs: {
      "title": "关闭"
    },
    on: {
      "click": _vm.closeTab
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('ul', {
    staticClass: "_citys0"
  }, [_c('li', {
    class: {
      active: _vm.isCity
    },
    on: {
      "click": function($event) {
        _vm.isCity = true
      }
    }
  }, [_vm._v("城市")]), _vm._v(" "), _c('li', {
    class: {
      active: !_vm.isCity
    },
    on: {
      "click": function($event) {
        _vm.isCity = false
      }
    }
  }, [_vm._v("区县")])]), _vm._v(" "), _c('div', {
    staticClass: "_citys1",
    class: {
      hidden: !_vm.isCity
    }
  }, _vm._l((_vm.getRegions), function(item, index) {
    return _c('a', {
      class: {
        selected: _vm.cityCode === item.code
      },
      on: {
        "click": function($event) {
          _vm.changeCity(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "_citys1",
    class: {
      hidden: _vm.isCity
    }
  }, _vm._l((_vm.districts), function(item, index) {
    return _c('a', {
      class: {
        selected: _vm.district === item
      },
      on: {
        "click": function($event) {
          _vm.changeRegion(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-163caa63!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/AreaPicker.vue
// module id = 1013
// module chunks = 40